import { object } from 'prop-types';
import cookies from 'react-cookies';
import withCallApi from '../utils/withCallApi';
import Login from './Login';
import MarketSelect from './MarketSelect';

const LoginPage = (mrktCfg) => {
  const mrktCd = (mrktCfg && mrktCfg.mrktCd) || cookies.load('mrktCd');
  const langCd = (mrktCfg && mrktCfg.langCd) || cookies.load('langCd');
  return ((mrktCd && langCd)
    ? withCallApi(Login, null, { defaultMarket: mrktCd, defaultLanguage: langCd }, true)
    : withCallApi(MarketSelect, null, {}, true));
};

LoginPage.propTypes = {
  mrktCfg: object,
};

export default LoginPage;
